import uuid from "uuid";

import {
  ADD_TO_CART,
  REMOVE_FROM_CART,
  CONTRACT_SIGNING_JOB_DOCUMENT,
  CONTRACT_SIGNING_POST_SIGNATURE,
  CONTRACT_SIGNING_SET_CUSTOM_FIELD,
  CONTRACT_SIGNING_SET_STEP,
  CONTRACT_SIGNING_SHOW_SIGNATURE_PAD,
  SET_AFTER_CONTRACT_SIGN_CALLBACK,
  SET_CONTRACT_BLOB,
  SHOW_CONTRACT_SIGNING,
  CHANGE_CART_FEATURE,
  CHANGE_CART_QUANTITY,
  CONTRACT_SIGNING_RESTORE_VALUES,
  SET_WIZARD_SELECTED_VALUES,
  CHANGE_ALL_CART_ITEMS,
  SET_CART_ITEMS_ADDED_TO_PARENT_CART,
  TOGGLE_PRICE_WORKSHEET_OPENED
} from "../actions/actionTypes";


const initialState = {
  firstName: '',
  lastName: '',
  step: 1,
  isVisible: false,
  callback: null,
  signedDocumentUrl: null,
  jobDocumentUrl: null,
  isSignaturePadVisible: false,
  signaturePadTag: null,
  invoiceNumberOfPages: null,
  savedInvoiceNumberOfPages: null, // is used to update filled in fields when invoice is changed and we need to update the fields
  pagesCustomFieldsValue: {},
  afterContractSignCallback: null,
  contractBlob: null,
  contractLoading: false,
  needToUpdateContract: false, // it is a detection for if job was updated!! then we need a new contract
  contractId: uuid.v4(), // it is a cached id, so contract is refreshed every time it needs to be changed
}

export default function(state = initialState, action){
  switch (action.type) {
    case SHOW_CONTRACT_SIGNING:
      return _show(state, action.payload);
    case CONTRACT_SIGNING_SET_STEP:
      return {...state, step: action.payload.step};
    case CONTRACT_SIGNING_POST_SIGNATURE:
    case SET_AFTER_CONTRACT_SIGN_CALLBACK:
    case SET_CONTRACT_BLOB:
    case CONTRACT_SIGNING_RESTORE_VALUES:
      return {...state, ...action.payload};
    case CONTRACT_SIGNING_SHOW_SIGNATURE_PAD:
      return {...state, isSignaturePadVisible: action.payload.show, signaturePadTag: action.payload.tag};
    case CONTRACT_SIGNING_SET_CUSTOM_FIELD:
      return setFieldValue(state, action.payload);
    case ADD_TO_CART:
    case REMOVE_FROM_CART:
    case CHANGE_CART_FEATURE:
    case CHANGE_CART_QUANTITY:
    case TOGGLE_PRICE_WORKSHEET_OPENED: // only if they opened, we cant set here set discount sections, because when restoring this is fired
    case SET_WIZARD_SELECTED_VALUES:
    case CHANGE_ALL_CART_ITEMS:
    case SET_CART_ITEMS_ADDED_TO_PARENT_CART:
      if (action.type === ADD_TO_CART && action.payload.cartItems.every(cItem => {
        return cItem.cartFeature && cItem.cartFeature.dbFeature.autoAddToCart
      })) {
        return state
      }
      if (!state.needToUpdateContract) {
        return {...state, needToUpdateContract: true, contractId: uuid.v4()};
      }
      return state
    case CONTRACT_SIGNING_JOB_DOCUMENT:
      if (Number.isInteger(action.payload.invoiceNumberOfPages)
        && Number.isInteger(state.savedInvoiceNumberOfPages)
        && (action.payload.invoiceNumberOfPages !== state.savedInvoiceNumberOfPages)
        && (Object.keys(state.pagesCustomFieldsValue).length)) {
        // on document load we are checking old receipt pages and new receipt pages, and then we update each selected value page
        console.log("receipt was changed, updating values... old pages and new pages:", state.savedInvoiceNumberOfPages, action.payload.invoiceNumberOfPages);
        let newValues = {};
        Object.keys(state.pagesCustomFieldsValue).forEach(oldPage => {
          // for example, if filled in page was 5 and there were 3 pages in receipt, and now receipt has 1 page - 5-3+1 = 3 page new
          const originalContractPage = oldPage - state.savedInvoiceNumberOfPages;
          const newPage = originalContractPage + action.payload.invoiceNumberOfPages;
          newValues[newPage] = state.pagesCustomFieldsValue[oldPage];
        });
        return {...state,
          ...action.payload,
          needToUpdateContract: false,
          pagesCustomFieldsValue: newValues,
          savedInvoiceNumberOfPages: action.payload.invoiceNumberOfPages, // update with new number, for the next time we open
        };
      }
      return {
        ...state,
        ...action.payload,
        needToUpdateContract: false,
        savedInvoiceNumberOfPages: action.payload.invoiceNumberOfPages // update with current invoice pages count
      };
  }
  return state;
}


function _show(state, {show, callback}) {
  if (!show) {
    return {...state, isVisible: false, step: 1, firstName: '', lastName: ''};
  }

  return {...state, isVisible: true, callback};
}


const setFieldValue = (state, {pageIndex, fieldIndex, name, value}) => {
  if (!state.pagesCustomFieldsValue[pageIndex]) {
    state.pagesCustomFieldsValue[pageIndex] = {};
  }

  state.pagesCustomFieldsValue[pageIndex][fieldIndex] = {name, value};
  return {...state, pagesCustomFieldsValue: {...state.pagesCustomFieldsValue}}
}

